import { FC, HTMLProps, useEffect, useRef, useState } from "react";
import { useGetSeoPage } from "contexts/SeoContext";
import { isBrowser } from "utils/nookies/utils";
import {useTheme} from "styled-components";

const SwitchLangAnchor: FC<HTMLProps<HTMLAnchorElement>> = ({
  children,
  ...props
}) => {
  const { link2: seoLink2 } = useGetSeoPage();
  const [href, setHref] = useState(seoLink2);
  const ref = useRef<HTMLAnchorElement>();
  const { locale } = useTheme();
  useEffect(() => {
    let href2 = seoLink2;
    if (window.location.href.includes("find")) {
      const path =
        locale === "ar"
          ? window.location.pathname.replace("ar", "en")
          : window.location.pathname.replace("en", "ar");
      href2 = path + window.location?.search;
    }
    if (
      window.location?.href?.includes("search=true") &&
      window.location?.search
    ) {
      href2 += window.location.search;
    }
    if (window.location.hash) {
      href2 += window.location.hash;
    }
    setHref(href2);
  }, [seoLink2, typeof window !== "undefined" && window.location.href]);

  const updatePostSearchLink = () => {
    if (window.location.href.includes("/search")) {
      if (window.location.href.includes("/ar/search")) {
        ref.current.setAttribute(
          "href",
          window.location.href.replace("/ar/search", "/en/search")
        );
      }
      if (window.location.href.includes("/en/search")) {
        ref.current.setAttribute(
          "href",
          window.location.href.replace("/en/search", "/ar/search")
        );
      }
    }
  };

  useEffect(() => {
    const t = setInterval(updatePostSearchLink, 1000);
    return () => clearInterval(t);
  }, []);

  const isSearch = href?.includes("search=true");

  return (
    <a
      {...props}
      href={isSearch ? seoLink2 : href}
      onClick={(e) => {
        if (isSearch) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = href;
        }
        return true;
      }}
      ref={ref}
    >
      {children}
    </a>
  );
};

export default SwitchLangAnchor;
